import { useContext } from "react";
import context, { ICognitoContext } from "./context";

export default (): ICognitoContext => useContext(context);
